<template>
  <div>


    <nav
      class="navbar navbar-expand-lg navbar-light bg-light "
    >
      <div class="container">
        <!-- <a class="navbar-brand" href="https://www.careers-page.com/cclick"> -->
          <router-link :to="{ name: 'home' }"  class="navbar-brand">
          <img

             src="https://manatal-backend-public-assets.s3.amazonaws.com/media/career_portal_logo_direct_upload/f77f49a2-43ab-4252-8e31-0f987e8253d7_Logo_CSIGROUP_1.2.png"
           
          />
             <!-- src="https://manatal-backend-public-assets.s3.amazonaws.com/media/career_portal_logo_direct_upload/02709938-82c6-440f-8347-1cfccea97483_golo.png" -->
          </router-link>
        <!-- </a> -->
        <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbar">
        <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse"  id="navbar">
          <ul class="navbar-nav ms-auto">
            <!--Website-->

            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.csigroups.com/"
                target="_blank"
                rel="”nofollow”"
              >
                <button type="button" class="btn btn-outline-secondary">
                  Company Website
                </button>
              </a>
            </li>

            <!--Phone number-->

            <li class="nav-item">
              <a class="nav-link" href="tel:+66 2 231 3851" target="_blank">
                <i class="fas fa-phone"></i>
              </a>
            </li>

            <!--Mail to-->

            <li class="nav-item">
              <a
                class="nav-link"
                href="mailto:info@cclick.co.th"
                target="_blank"
              >
                <i class="fas fa-envelope"></i>
              </a>
            </li>

            <!-- Twitter -->

            <!--Facebook-->

            <li class="nav-item">
              <a
                class="nav-link"
                href="https://web.facebook.com/csigroupsofficial"
                target="_blank"
                rel="”nofollow”"
              >
                <i class="fab fa-facebook"></i>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href="https://youtube.com/c/CSIGroups_IT"
                target="_blank"
                rel="”nofollow”"
              >
                <i class="fab fa-youtube"></i>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.linkedin.com/in/c-s-i-group-48b7a3212"
                target="_blank"
                rel="”nofollow”"
              >
                <i class="fab fa-linkedin"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },

}
</script>

<style scoped>
.nav-item{
  margin:0px auto 0px auto;
}


img, video {
    max-width: 100%;
    height:66px;
}
</style>